/* Whisply quick buy: card buttons open a window to pick the frame colour, optionally with Rx. */
const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const $ = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];
const clean = (v) => String(v || '').replace(/\s*[-–]\s*low stock/i, '').replace(/\s*\(new\)/i, '').trim();
const isLow = (t) => /low stock/i.test(t || '');
const fmt = (cents) => { const d = (cents / 100).toFixed(2); return '$' + (d.endsWith('.00') ? d.slice(0, -3) : d); };
const sized = (src, w) => { if (!src) return ''; const u = src.startsWith('//') ? 'https:' + src : src; return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };
const q2 = (n) => (n > 0 ? '+' : '') + n.toFixed(2);

const qb = $('#w-qb');
if (qb) {
  const els = {
    panel: $('.w-qb__panel', qb), img: $('[data-w-qb-img]', qb), title: $('[data-w-qb-title]', qb), eyebrow: $('[data-w-qb-eyebrow]', qb),
    price: $('[data-w-qb-price]', qb), was: $('[data-w-qb-was]', qb), save: $('[data-w-qb-save]', qb), opts: $('[data-w-qb-opts]', qb),
    rxWrap: $('[data-w-qb-rx]', qb), err: $('[data-w-qb-err]', qb), add: $('[data-w-qb-add]', qb), label: $('[data-w-qb-add-label]', qb), link: $('[data-w-qb-link]', qb)
  };
  const rx = els.rxWrap && $('[data-w-rx]', els.rxWrap);
  const fees = rx ? JSON.parse($('[data-w-rx-fees]', rx).textContent) : null;
  let product = null, variant = null, colorIdx = -1, rxMode = 'frame', lastFocus = null;
  const cache = {};

  /* ---------- Rx form wiring (same markup as the product page) ---------- */
  const val = (k) => { const e = rx && $(`[data-rx="${k}"]`, rx); return e ? e.value.trim() : ''; };
  const feeFor = () => { const c = Math.min(parseFloat(val('od_cyl')) || 0, parseFloat(val('os_cyl')) || 0); return c <= -4.25 ? fees.large : c <= -2.25 ? fees.medium : fees.small; };
  if (rx) {
    $$('select[data-rx$="_sph"]', rx).forEach((s) => { s.innerHTML = '<option value="">Select</option>'; for (let n = 24; n >= -32; n--) { const o = document.createElement('option'); o.textContent = n === 0 ? '0.00' : q2(n / 4); s.appendChild(o); } });
    $$('select[data-rx$="_cyl"]', rx).forEach((s) => { s.innerHTML = '<option value="">None</option>'; for (let n = -1; n >= -24; n--) { const o = document.createElement('option'); o.textContent = (n / 4).toFixed(2); s.appendChild(o); } });
    $$('[data-rx-mode]', rx).forEach((t) => t.addEventListener('click', () => setRx(t.dataset.rxMode)));
    const dual = $('[data-rx-dual]', rx);
    dual.addEventListener('change', () => { $('[data-rx-pd2]', rx).hidden = !dual.checked; $('[data-rx="pd"]', rx).closest('label').style.opacity = dual.checked ? '.4' : '1'; });
    const sync = () => {
      const f = feeFor(), key = f === fees.large ? 'large' : f === fees.medium ? 'medium' : 'small';
      $('[data-rx-tier]', rx).textContent = f.label;
      $('[data-rx-fee-price]', rx).textContent = '+' + fmt(f.price);
      $$('[data-rx-t]', rx).forEach((t) => t.classList.toggle('is-on', t.dataset.rxT === key));
      const th = $('[data-rx-thumb]', rx); if (th) th.style.transform = 'translateX(' + ({ small: 0, medium: 1, large: 2 }[key] * 100) + '%)';
      $$('select[data-rx], input[data-rx]', rx).forEach((x) => { x.classList.toggle('is-filled', !!x.value); if (x.value) x.classList.remove('is-invalid'); });
      const eyes = !!(val('od_sph') && val('os_sph')), pd = dual.checked ? !!(val('pd_r') && val('pd_l')) : !!val('pd'), ok = $('[data-rx-confirm]', rx).checked;
      const done = [eyes, pd, ok], cur = done.indexOf(false);
      $$('[data-rx-step]', rx).forEach((s, i) => { s.classList.toggle('is-done', done[i]); s.classList.toggle('is-on', i === cur || done[i]); });
      const p = $('[data-rx-progress]', rx); if (p) p.style.width = Math.max(8, (done.filter(Boolean).length / 3) * 100) + '%';
      label();
    };
    rx.addEventListener('change', sync); rx.addEventListener('input', sync);
  }
  function setRx(mode) {
    rxMode = mode;
    if (!rx) return;
    $$('[data-rx-mode]', rx).forEach((x) => x.setAttribute('aria-selected', String(x.dataset.rxMode === mode)));
    $('[data-rx-panel]', rx).hidden = mode !== 'rx';
    rx.classList.toggle('is-rx', mode === 'rx');
    els.eyebrow.textContent = mode === 'rx' ? 'Frame + prescription lenses' : 'Quick add';
    label();
  }
  function validateRx() {
    const dual = $('[data-rx-dual]', rx).checked, need = ['od_sph', 'os_sph'].concat(dual ? ['pd_r', 'pd_l'] : ['pd']);
    let bad = null;
    need.forEach((k) => { const el = $(`[data-rx="${k}"]`, rx); if (!el.value) { el.classList.add('is-invalid'); bad = bad || el; } });
    if (bad) { bad.focus(); return 'Please add SPH for both eyes and your PD.'; }
    for (const e of ['od', 'os']) {
      const c = val(e + '_cyl'), a = val(e + '_axis');
      if ((c && !a) || (!c && a)) { const el = $(`[data-rx="${e}_axis"]`, rx); el.classList.add('is-invalid'); el.focus(); return (e === 'od' ? 'Right' : 'Left') + ' eye: CYL and AXIS go together.'; }
    }
    if (!$('[data-rx-confirm]', rx).checked) return 'Please confirm your prescription is valid.';
    return null;
  }
  function resetRx() {
    if (!rx) return;
    $$('select[data-rx], input[data-rx]', rx).forEach((x) => { x.value = ''; x.classList.remove('is-invalid', 'is-filled'); });
    $('[data-rx-confirm]', rx).checked = false; $('[data-rx-dual]', rx).checked = false; $('[data-rx-pd2]', rx).hidden = true;
    rx.dispatchEvent(new Event('change'));
  }

  /* ---------- product + colour picker ---------- */
  function label() {
    if (!variant) return;
    if (!variant.available) { els.label.textContent = 'Sold out'; els.add.disabled = true; return; }
    els.add.disabled = false;
    const withRx = rx && rxMode === 'rx';
    els.label.textContent = (withRx ? 'Add with Rx' : 'Add to cart') + ' — ' + fmt(variant.price + (withRx ? feeFor().price : 0));
  }
  function pick(v) {
    variant = v;
    const src = (v.featured_image && v.featured_image.src) || product.featured_image;
    els.img.style.opacity = '0';
    setTimeout(() => { els.img.src = sized(src, 1000); els.img.onload = () => (els.img.style.opacity = '1'); }, 120);
    els.price.textContent = fmt(v.price);
    const save = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
    els.was.hidden = !save; els.was.textContent = fmt(v.compare_at_price || 0);

    $$('[data-w-qb-val]', els.opts).forEach((b) => b.setAttribute('aria-pressed', String(v.options[+b.dataset.oi] === b.dataset.wQbVal)));
    $$('[data-w-qb-optlabel]', els.opts).forEach((l) => { const i = +l.dataset.oi; l.innerHTML = '<b>' + clean(v.options[i]) + '</b>' + ''; });
    label();
  }
  function renderOptions() {
    els.opts.innerHTML = '';
    if (product.variants.length < 2) return;
    product.options.forEach((opt, oi) => {
      const name = typeof opt === 'string' ? opt : opt.name;
      const values = [...new Set(product.variants.map((v) => v.options[oi]))];
      const isColor = oi === colorIdx;
      const f = document.createElement('div'); f.className = 'w-qb__opt';
      f.innerHTML = `<span class="w-qb__optname">${name}: <span data-w-qb-optlabel data-oi="${oi}"></span></span><div class="w-qb__vals${isColor ? ' is-sw' : ''}"></div>`;
      const wrap = $('.w-qb__vals', f);
      values.forEach((val) => {
        const v = product.variants.find((x) => x.options[oi] === val);
        const b = document.createElement('button'); b.type = 'button'; b.dataset.wQbVal = val; b.dataset.oi = oi; b.title = clean(val); b.setAttribute('aria-label', clean(val));
        if (isColor && v && v.featured_image) { b.className = 'w-qb__sw'; b.innerHTML = `<img src="${sized(v.featured_image.src, 200)}" alt="" loading="lazy">`; }
        else { b.className = 'w-qb__pill'; b.textContent = clean(val); }
        if (v && !v.available) b.classList.add('is-out');
        b.addEventListener('click', () => {
          const cur = variant.options.slice(); cur[oi] = val;
          const m = product.variants.find((x) => x.options.every((o, i) => o === cur[i])) || product.variants.find((x) => x.options[oi] === val && x.available) || v;
          pick(m);
        });
        wrap.appendChild(b);
      });
      els.opts.appendChild(f);
    });
  }

  async function open(handle, mode, trigger) {
    lastFocus = trigger || document.activeElement;
    els.err.hidden = true;
    qb.hidden = false; requestAnimationFrame(() => qb.classList.add('is-open'));
    document.documentElement.classList.add('w-cd-lock');
    qb.classList.add('is-loading');
    try {
      product = cache[handle] || (cache[handle] = await (await fetch(root + 'products/' + handle + '.js')).json());
    } catch (e) { close(); location.href = root + 'products/' + handle; return; }
    qb.classList.remove('is-loading');
    colorIdx = product.options.findIndex((o) => /colou?r|lens/i.test(typeof o === 'string' ? o : o.name));
    els.title.textContent = product.title;
    const bd = $('[data-w-qb-badges]', qb); if (bd) bd.hidden = !((window.WhisplySettings && WhisplySettings.topSellers) || []).includes(product.handle);
    els.link.href = product.url || root + 'products/' + handle;
    renderOptions();
    pick(product.variants.find((v) => v.available) || product.variants[0]);
    if (els.rxWrap) { els.rxWrap.hidden = mode !== 'rx' && !trigger?.dataset.rxOk; resetRx(); }
    setRx(mode === 'rx' ? 'rx' : 'frame');
    setTimeout(() => els.panel.focus({ preventScroll: true }), 60);
  }
  function close() {
    qb.classList.remove('is-open');
    document.documentElement.classList.remove('w-cd-lock');
    setTimeout(() => { qb.hidden = true; }, 350);
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }

  els.add.addEventListener('click', async () => {
    if (!variant || !variant.available) return;
    els.err.hidden = true;
    const items = [];
    if (rx && rxMode === 'rx') {
      const msg = validateRx(); if (msg) { els.err.textContent = msg; els.err.hidden = false; return; }
      const f = feeFor(), dual = $('[data-rx-dual]', rx).checked;
      const pd = dual ? `R ${val('pd_r')} / L ${val('pd_l')}` : val('pd');
      const line = (k) => `SPH ${val(k + '_sph')} · CYL ${val(k + '_cyl') || 'None'} · AXIS ${val(k + '_axis') || '-'}`;
      const pair = 'rxpair-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      items.push({ id: variant.id, quantity: 1, properties: { Prescription: `RX Size: ${f.label}\nRight Eye (OD): ${line('od')}\nLeft Eye (OS): ${line('os')}\nPD: ${pd}`, '_Whisply RX Pair': pair } });
      items.push({ id: f.id, quantity: 1, properties: { '_Lab Cost': f.lab, '_Whisply RX Pair': pair, '_RX': `OD:${val('od_sph')}/${val('od_cyl') || '0'}x${val('od_axis') || '000'} | OS:${val('os_sph')}/${val('os_cyl') || '0'}x${val('os_axis') || '000'} | PD:${pd}` } });
    } else items.push({ id: variant.id, quantity: 1 });
    els.add.classList.add('is-busy');
    try { await window.Whisply.addToCart(items, els.add); close(); }
    catch (e) { els.err.textContent = e.message || 'Could not add to cart'; els.err.hidden = false; }
    els.add.classList.remove('is-busy');
  });
  qb.addEventListener('click', (e) => { if (e.target.closest('[data-w-qb-close]')) close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && qb.classList.contains('is-open')) close(); });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-w-qb]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    open(t.dataset.wQb, t.dataset.mode, t);
  }, true);
}
